jQuery(document).ready(function() {
      jQuery('.service-slider').slick({
      slidesToShow: 3,
      arrows: true,
      dots: true,
      centerMode: true,
       centerPadding: '0',
      infinite: true,
        responsive: [
        {
          breakpoint: 849,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '150px',
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '100px',
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '80px',
          }
        }
      ]
    });

    jQuery('.discover-slider').slick({
      slidesToShow: 3,
      arrows: true,
      dots: true,
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 5000,
        responsive: [

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
 
       jQuery('.usp-section').slick({
        slidesToShow: 4,
        arrows: false,
        dots: false,
        centerMode: true,
         centerPadding: '0',
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
          responsive: [

          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px'
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: false,
              centerPadding: '0'
            }
          }
        ]
      });
  
      jQuery('.custom-usp').slick({
        slidesToShow: 4,
        arrows: false,
        dots: false,
        centerMode: true,
         centerPadding: '0',
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
          responsive: [

          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px'
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px'
            }
          }
        ]
      });
  
       jQuery('.brands-list').slick({
        slidesToShow: 6,
        arrows: false,
        dots: false,
        centerMode: true,
        autoplay: true,
        centerPadding: '0',
        infinite: true,
        autoplaySpeed: 5000,
          responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px'
            }
          },

          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px'
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px'
            }
          }
        ]
      });
  
 jQuery('.faq-text-heading').on('click', function(){
 jQuery(this).parents('.collapsible-box-container').find('.collapsible-box').toggleClass('active');
  jQuery(this).parents('.collapsible-box').find('.faq-box-content').slideToggle();

})
 jQuery(document).on('click','.globo-swatch-product-detail .swatch--gl li[data-value="Leasen"] label', function(){
    jQuery('.globo-swatch-product-detail .swatch--gl[data-option-index="2"]').show();
    jQuery('.product-form__item--submit').hide();
   jQuery('.lease-scooter-btn').show();
   jQuery('.show-on-leasen').show();
   

});
   jQuery(document).on('click','.globo-swatch-product-detail .swatch--gl li[data-value="Kopen"] label', function(){
    jQuery('.globo-swatch-product-detail .swatch--gl[data-option-index="2"]').hide();
     jQuery('.product-form__item--submit').show();
     jQuery('.lease-scooter-btn').hide();
      jQuery('.show-on-leasen').hide();
})


  jQuery(window).on('load', function() {
    if (jQuery('.globo-swatch-product-detail ul.value li.select-option input[value="Leasen"]:checked').length) {
      jQuery('.globo-swatch-product-detail .swatch--gl[data-option-index="2"]').show();
      jQuery('.product-form__item--submit').hide();
     jQuery('.show-on-leasen').show();
      
  }
});


});



